/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Select_Source_Extract_LabelInputs */



/**
* | output |
* | --- |
* | "Select Source Files (.mp4, .mov, .mxf, etc)" |
*
* @param {Drastic_Tech_Select_Source_Extract_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_select_source_extract_label = /** @type {((inputs?: Drastic_Tech_Select_Source_Extract_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Select_Source_Extract_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner les fichiers source (.mp4, .mov, .mxf, etc)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quelldateien auswählen (.mp4, .mov, .mxf usw.)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona i file sorgente (.mp4, .mov, .mxf, ecc.)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите исходные файлы (.mp4, .mov, .mxf и т. д.)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar archivos de origen (.mp4, .mov, .mxf, etc.)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择源文件（.mp4、.mov、.mxf 等）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースファイルを選択（.mp4、.mov、.mxfなど）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत फ़ाइलें चुनें (.mp4, .mov, .mxf, आदि)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione os arquivos de origem (.mp4, .mov, .mxf, etc.)")
	return /** @type {LocalizedString} */ ("Select Source Files (.mp4, .mov, .mxf, etc)")
});